<template>
  <div>

    <!-- background -->
    <div class="my-modal-backdrop" @click="backdropClick" :class="{
            hidden: !visible,
            'visible-backdrop': visible
          }"></div>

    <!-- foreground -->
    <div class="my-modal-wrapper elevation-5" :class="{
            hidden: !visible,
            'visible-wrapper': visible,
            'pa-2': !noPadding
          }" :style="wrapperStyle">

      <!-- header -->
      <slot name="header">
        <h2 v-if="header != null" class="mb-2" :class="{
                'd-flex': closeButton
              }" :style="{
                'padding-right': closeButton ? '2px' : '5px'
              }">
          <span v-html="header"></span>
          <v-spacer v-if="closeButton"></v-spacer>
          <v-btn v-if="closeButton" class="mr-0" x-small color="primary" @click="hide" style="">Close</v-btn>
        </h2>
      </slot>

      <!-- modal content -->
      <div :style="contentStyle">
        <slot></slot>
      </div>

    </div>

  </div>
</template>

<script>
export default {
  props: {
    noPadding: Boolean,
    header: null,
    width: null,
    height: null,
    closeButton: Boolean
  },
  data() {
    return {
      visible: false
    }
  },
  computed: {
    wrapperStyle() {
      var x = {}
      if (Number.isInteger(this.width) || !isNaN(this.width)) {
        x['max-width'] = `${this.width}px`
        x['min-width'] = `${this.width}px`
      } else if (this.width != null) {
        x['max-width'] = `${this.width}`
        x['min-width'] = `${this.width}`
      }
      if (Number.isInteger(this.height) || !isNaN(this.height)) {
        x['max-height'] = `${this.height}px`
        x['min-height'] = `${this.height}px`
      } else if (this.height != null) {
        x['max-height'] = `${this.height}`
        x['min-height'] = `${this.height}`
      }
      return x
    },
    contentStyle() {
      var x = {}
      if (Number.isInteger(this.height) || !isNaN(this.height)) {
        x['max-height'] = `${this.height - 50}px`
        x['min-height'] = `${this.height - 50}px`
        x['overflow-y'] = 'auto'
      }
      return x
    }
  },
  mounted() {},
  methods: {
    show() {
      this.$emit('before-show')
      this.visible = true
      this.$emit('after-show')
    },
    hide() {
      this.$emit('before-hide')
      this.visible = false
      this.$emit('after-hide')
    },
    backdropClick() {
      if (!this.closeButton) {
        this.hide()
      }
    }
  }
}
</script>




<style lang="scss" scoped>
.my-modal-backdrop {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: dimgray;
  z-index: 100;
}

.my-modal-wrapper {
  border-radius: 2px;
  background-color: white;
  z-index: 101;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translateX(-50%) translatey(-50%);
  min-width: 300px;
  min-height: 100px;
  overflow-y: auto;
}

.visible-backdrop {
  visibility: visible;
  opacity: 0.4;
  transition: opacity 0.2s linear;
}

.visible-wrapper {
  visibility: visible;
  opacity: 1;
  transition: opacity 0.2s linear;
}

.hidden {
  visibility: hidden;
  opacity: 0;
  transition: visibility 0s 0.2s, opacity 0.2s linear;
}
</style>